import styled from 'styled-components';

export const SelectLabel = styled.label`
  color: ${({ theme }) => theme.colors.primary.grey};
  font-size: 14px;
  line-height: 22px;
  font-family: Inter, sans-serif;
  margin-bottom: 4px;
`;

export const FieldContainer = styled.div`
  margin-bottom: 14px;
`;
